// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const voiceVideoSections: PaneSection[] = [
  {
    section: 'overview',
    title: 'Voice and video',
    body: 'This is where you will pick the camera and microphone Ping uses for your calls. It is on the way, so check back soon.',
  },
];
